"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSignatureInfoModalStyles = void 0;
var core_1 = require("@material-ui/core");
var common_1 = require("../../../common");
exports.useSignatureInfoModalStyles = core_1.makeStyles(function (theme) {
    var signature = theme.variables.palette.crypto.signature;
    return {
        bar: {
            color: function (_a) {
                var signatureStatus = _a.signatureStatus;
                return signatureStatus === common_1.SignatureStatus.VALID ? signature.valid : signature.defaultEdit;
            },
            backgroundColor: function (_a) {
                var signatureStatus = _a.signatureStatus;
                return signatureStatus === common_1.SignatureStatus.VALID ? signature.validLight : signature.invalidLight;
            },
        },
    };
});
